function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Draggable from 'vuedraggable';
import '@/components/form-designer/form-widget/container-widget/index';
import FieldComponents from '@/components/form-designer/form-widget/field-widget/index';
import i18n from '@/utils/i18n';
import { containers } from '@/components/form-designer/widget-panel/widgetsConfig';
import { el } from '@fullcalendar/core/internal-common';
export default {
  name: 'VFormWidget',
  componentName: 'VFormWidget',
  mixins: [i18n],
  components: _objectSpread({
    Draggable: Draggable
  }, FieldComponents),
  props: {
    designer: Object,
    formConfig: Object,
    optionData: {
      //prop传入的选项数据
      type: Object,
      default: function _default() {
        return {};
      }
    },
    globalDsv: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  provide: function provide() {
    var _this = this;
    return {
      refList: this.widgetRefList,
      formConfig: this.formConfig,
      getGlobalDsv: function getGlobalDsv() {
        return _this.globalDsv;
      },
      // 全局数据源变量
      globalOptionData: this.optionData,
      getOptionData: function getOptionData() {
        return _this.optionData;
      },
      globalModel: {
        formModel: this.formModel
      }
    };
  },
  inject: ['getDesignerConfig'],
  data: function data() {
    return {
      formModel: {},
      widgetRefList: {},
      containersNames: containers.map(function (con) {
        return con.type;
      })
    };
  },
  computed: {
    labelPosition: function labelPosition() {
      if (!!this.designer.formConfig && !!this.designer.formConfig.labelPosition) {
        return this.designer.formConfig.labelPosition;
      }
      return 'left';
    },
    size: function size() {
      if (!!this.designer.formConfig && !!this.designer.formConfig.size) {
        return this.designer.formConfig.size;
      }
      return 'medium';
    },
    customClass: function customClass() {
      return this.designer.formConfig.customClass || '';
    },
    layoutType: function layoutType() {
      return this.designer.getLayoutType();
    }
  },
  watch: {
    'designer.widgetList': {
      deep: true,
      handler: function handler(val) {
        //
      }
    },
    'designer.formConfig': {
      deep: true,
      handler: function handler(val) {
        //
      }
    }
  },
  created: function created() {
    this.designer.initDesigner(!!this.getDesignerConfig().resetFormJson);
    this.designer.loadPresetCssCode(this.getDesignerConfig().presetCssCode);
  },
  mounted: function mounted() {
    this.disableFirefoxDefaultDrop();
    this.designer.registerFormWidget(this);
  },
  methods: {
    getWidgetName: function getWidgetName(widget) {
      return widget.type + '-widget';
    },
    /* 禁用Firefox默认拖拽搜索功能!! */disableFirefoxDefaultDrop: function disableFirefoxDefaultDrop() {
      var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') !== -1;
      if (isFirefox) {
        document.body.ondrop = function (event) {
          event.stopPropagation();
          event.preventDefault();
        };
      }
    },
    onDragEnd: function onDragEnd(evt) {
      var newIndex = evt.newIndex;
      if (!!this.designer.widgetList[newIndex]) {
        this.designer.setSelected(this.designer.widgetList[newIndex]);
      }
    },
    onDragAdd: function onDragAdd(evt) {
      var newIndex = evt.newIndex;
      var widget = this.designer.widgetList[newIndex];
      var name = this.widgetNameFilter(widget);
      if (!!this.designer.widgetList[newIndex]) {
        this.designer.setNamesList(this.designer.widgetList[newIndex]);
        this.designer.setSelected(this.designer.widgetList[newIndex]);
      }
      this.designer.emitHistoryChange(name);
      this.designer.emitEvent('field-selected', null);
    },
    onDragUpdate: function onDragUpdate() {
      /* 在VueDraggable内拖拽组件发生位置变化时会触发update，未发生组件位置变化不会触发！！ */
      this.designer.emitHistoryChange();
    },
    checkMove: function checkMove(evt) {
      return this.designer.checkWidgetMove(evt);
    },
    getFormData: function getFormData() {
      return this.formModel;
    },
    getWidgetRef: function getWidgetRef(widgetName) {
      var showError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var foundRef = this.widgetRefList[widgetName];
      if (!foundRef && !!showError) {
        this.$message.error(this.i18nt('render.hint.refNotFound') + widgetName);
      }
      return foundRef;
    },
    getSelectedWidgetRef: function getSelectedWidgetRef() {
      var wName = this.designer.selectedWidgetName;
      return this.getWidgetRef(wName);
    },
    clearWidgetRefList: function clearWidgetRefList() {
      var _this2 = this;
      Object.keys(this.widgetRefList).forEach(function (key) {
        delete _this2.widgetRefList[key];
      });
    },
    widgetNameFilter: function widgetNameFilter(obj) {
      var type = containers.map(function (con) {
        return con.type;
      });
      if (!type.includes(obj.type)) {
        return obj.options.name;
      } else {
        return '';
      }
    },
    crudStatusFilter: function crudStatusFilter(obj, nameArr) {
      var _this3 = this;
      var names = nameArr;
      if (obj.type === 'grid') {
        this.crudStatusFilter(obj.cols, names);
      } else if (obj.type === 'grid-col' && obj.widgetList) {
        obj.widgetList.forEach(function (item) {
          if (_this3.containersNames.includes(item.type)) {
            _this3.crudStatusFilter(item, names);
          } else {
            names.push(item.options.name);
          }
        });
      } else if (obj.type === 'card' && obj.widgetList.length) {
        obj.widgetList.forEach(function (item) {
          if (_this3.containersNames.includes(item.type)) {
            _this3.crudStatusFilter(item, names);
          } else {
            names.push(item.options.name);
          }
        });
      } else if (obj.type === 'tab' && obj.tabs.length) {
        obj.tabs.forEach(function (item) {
          if (item.type === 'tab-pane') {
            item.widgetList.forEach(function (item2) {
              if (_this3.containersNames.includes(item2.type)) {
                _this3.crudStatusFilter(item2, names);
              } else {
                names.push(item2.options.name);
              }
            });
          }
        });
      } else if (Array.isArray(obj) && obj.length) {
        obj.forEach(function (item) {
          _this3.crudStatusFilter(item, names);
        });
        // if (!this.containersNames.includes(obj.type)) return [obj.options.name]
      }
      return names;
    },
    deleteWidgetRef: function deleteWidgetRef(widgetRefName, removeWidget) {
      var _this4 = this;
      if (widgetRefName) {
        var index = this.designer.selectNames.findIndex(function (name) {
          return name === widgetRefName;
        });
        this.designer.selectNames.splice(index, 1);
      } else if (removeWidget) {
        var arr = [];
        var names = this.crudStatusFilter(removeWidget, arr);
        names.forEach(function (name) {
          var index = _this4.designer.selectNames.findIndex(function (n) {
            return n === name;
          });
          _this4.designer.selectNames.splice(index, 1);
        });
      }

      // delete this.widgetRefList[widgetRefName]
    }
  }
};